import { apiURL, axios } from '../main'

export default {
    state: { // state des Moduls wird direkt auf die variable state.modulX gemappt
        beziehungen: [
            /*{
                "ort": "Menznau",
                "bid": "42369",
                "agis": "10087574",
                "plz": "6122",
                "betriebform": "Ganzjahresbetrieb",
                "strasse": "testweg",
                "org": [{ "name": "Zentralschweizer Milchproduzenten" }],
                "milchkaeufer": [
                    {
                        "mbh": 41370,
                        "von": "2006-05-01T00:00:00+02:00",
                        "sst": [{ "mbh": "", "von": "2012-01-01T00:00:00+01:00", "sstname": "Buholz Sammelstelle", "bis": "", "name2": "Othmar", "name": "Schürmann" }],
                        "verwerterperid": 62,
                        "verrid": 48472,
                        "tierartid": 1,
                        "bis": "",
                        "name": "Zentralschweizer Milchproduzenten"
                    }]
            }
            */
        ]
    },
    actions: {
        loadBeziehungen: async function ({ commit }) {

            try {
                var beziehungen = await axios.get(apiURL + 'beziehungen.cfc?method=getData')
                commit('setBeziehungen', beziehungen.data)
            }
            catch (e) {
                //etwas ist schief gelaufen jahr wieder entfernen
                commit('setBeziehungen', [])
            }

        }
    },
    mutations: { //call with this.$store.commit('setExampleFn',{'a':'b'})
        setBeziehungen: function (state, data) {
            state.beziehungen = data
        },


    }
}